export const scaleByMagnitude = (seriesArray, measurementType) => {
  const flatValues = seriesArray
    .flat()
    .filter(v => v !== null && v !== undefined);

  if (!flatValues.length) {
    return { factor: 1, unit: "" };
  }

  const maxAbs = Math.max(...flatValues.map(v => Math.abs(v)));

  let factor = 1;
  let unit = "";

  switch (measurementType) {

    // POTENCIA ACTIVA
    case "potencia activa":
      unit = "W";
      if (maxAbs >= 1_000_000) {
        factor = 1_000_000;
        unit = "MW";
      } else if (maxAbs >= 1_000) {
        factor = 1_000;
        unit = "kW";
      }
      break;

    // POTENCIA REACTIVA
    case "potencia reactiva":
      unit = "VAR";
      if (maxAbs >= 1_000_000) {
        factor = 1_000_000;
        unit = "MVAR";
      } else if (maxAbs >= 1_000) {
        factor = 1_000;
        unit = "kVAR";
      }
      break;

    // ENERGÍA ACTIVA (ya viene en kWh)
    case "energia activa":
      unit = "kWh";
      if (maxAbs >= 1_000_000) {
        factor = 1_000_000;
        unit = "GWh";
      } else if (maxAbs >= 1_000) {
        factor = 1_000;
        unit = "MWh";
      }
      break;

    // ENERGÍA REACTIVA (kVARh)
    case "energia reactiva":
      unit = "kVARh";
      if (maxAbs >= 1_000_000) {
        factor = 1_000_000;
        unit = "GVARh";
      } else if (maxAbs >= 1_000) {
        factor = 1_000;
        unit = "MVARh";
      }
      break;

    default:
      factor = 1;
      unit = "";
  }

  return { factor, unit };
};
